import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LANGUAGE_CODES } from '../types/language'
import deTranslations from './locales/de.json'
import enTranslations from './locales/en.json'
import esTranslations from './locales/es.json'
import frTranslations from './locales/fr.json'
import itTranslations from './locales/it.json'
import jaTranslations from './locales/ja.json'
import nlTranslations from './locales/nl.json'
import ptTranslations from './locales/pt.json'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: LANGUAGE_CODES,
  resources: {
    de: { translation: deTranslations },
    en: { translation: enTranslations },
    es: { translation: esTranslations },
    fr: { translation: frTranslations },
    it: { translation: itTranslations },
    ja: { translation: jaTranslations },
    nl: { translation: nlTranslations },
    pt: { translation: ptTranslations },
  },
  interpolation: {
    escapeValue: false, // React already does escaping
  },
})

export default i18n
